import LetterAvatar from "@/components/Avatar/LetterAvatar"

export const columns = [
  {
    header: "Name",
    cell: ({ row }) => <LetterAvatar name={row.original.name} />,
  },
  {
    header: "Phone",
    accessorKey: "phone",
  },
  {
    header: "Location",
    accessorKey: "location",
  },
  {
    header: "PAN/VAT No",
    accessorKey: "vat_pan_number",
  },
]
